<template lang="html">
  <div class="sailWindForm">
    <!-- 申请信息 -->
    <div class="applyForInfo">
      <div class="hint">
        <p></p>
        <div>申请信息</div>
      </div>

      <div class="formInfo">
        <div>姓名<span>*</span></div>
        <input placeholder="请输入姓名" name="infoInput" class="infoInput" type="text" maxlength="10" v-model="userName">
      </div>
      <div class="formInfo">
        <div>手机号码<span>*</span></div>
        <input placeholder="请输入手机号码" name="infoInput" class="infoInput" type="text" maxlength="11" v-model="userPhone">
      </div>
      <div class="formInfo">
        <div>公司名称<span>*</span></div>
        <input placeholder="请输入公司名称" name="infoInput" class="infoInput" type="text" maxlength="20" v-model="userCpName">
      </div>
      <div class="formInfo">
        <div>所属行业<span>*</span></div>
        <input placeholder="请选择所属行业" name="infoInput" class="infoInput" type="text" maxlength="10" v-model="industryName" disabled>
        <img src="@/assets/image/sailWind/icon3.png" alt="">
        <div class="shade" @click="getIndustry"></div>
      </div>
      <div class="formInfo">
        <div>职位<span>*</span></div>
        <input placeholder="请输入职务" name="infoInput" class="infoInput" type="text" maxlength="10" v-model="userPostName">
      </div>
      <div class="formInfo">
        <div>邮箱<span>*</span></div>
        <input placeholder="请输入邮箱" name="infoInput" class="infoInput" type="text" maxlength="30" v-model="userEmail">
      </div>
    </div>

    <!-- 申请详情 -->
    <div class="applyForParticulars">
      <div class="hint">
        <p></p>
        <div>申请详情</div>
      </div>

      <div class="tool">
        <div class="toolHint">
          <div>目前使用工具<span>*</span></div>
        </div>

        <div class="userTool" @click="useTheToolsShow = true">
          <div class="userToolCon" v-if="meetingArr.length == 0">{{ userTool }}</div>
          <div class="userToolCons" v-else>
            <span v-for="(a, index) in meetingArr" :key="index"> {{ meetingData[a-1].label }}、 </span>
          </div>
          <img src="@/assets/image/sailWind/icon3.png" alt="">
        </div>
      </div>

      <div class="function">
        <div class="toolHint">
          <div>试用侧重功能<span>*</span></div>
        </div>

        <div class="functionCon">
          <textarea placeholder="请输入" name="userLocation" class="userLocation" maxlength="200" v-model='location'></textarea>
          <p>{{ location.length }}<span>/200</span></p>
        </div>
      </div>
    </div>

    <!-- 系统配置 -->
    <div class="applyForAllocations">
      <div class="hint">
        <p></p>
        <div>系统配置</div>
      </div>

      <div class="system">
        <div class="toolHint">
          <div>电脑操作系统<span>*</span></div>
        </div>

        <div class="systemCon">
          <div class="systemConOption" :class="{checked: systemType == '1'}" @click="getSystemType(1)">
            <span> {{ 'windows7' }} </span>
          </div>
          <div class="systemConOption" :class="{checked: systemType == '2'}" @click="getSystemType(2)">
            <span> {{ 'windows10' }} </span>
          </div>
          <div class="systemConOption" :class="{checked: systemType == '3'}" @click="getSystemType(3)">
            <span> {{ 'windows11' }} </span>
          </div>
          <div class="systemConOption" :class="{checked: systemType == '4'}" @click="getSystemType(4)">
            <span> {{ '其他' }} </span>
          </div>
        </div>
        
        <div class="elseSystemCon" maxlength="20" v-show="systemType == '4'">
          <input type="text" v-model="otherInformation">
        </div>
      </div>
    </div>

    <!-- 期望测试时间 -->
    <div class="testTime">
      <div class="hint">
        <p></p>
        <div>期望测试时间</div>
      </div>

      <div class="systemCon">
        <div class="timeA" :class="{checkeds: timeType == '1'}" @click="getTimeType(1)">
          <span> {{ '3个工作日' }} </span>
        </div>
        <div class="timeA" :class="{checkeds: timeType == '2'}" @click="getTimeType(2)">
          <span> {{ '10个工作日' }} </span>
        </div>
        <div class="timeA" :class="{checkeds: timeType == '3'}" @click="getTimeType(3)">
          <span> {{ '15个工作日' }} </span>
        </div>
      </div>
    </div>

    <!-- 提交 -->
    <div class="submitBtn">
      <div @click="debouncedGetSubmit" :class="{submitBtnElse: submitEnabled}">提交</div>
    </div>

    <div v-show="hintShow" class="hintMod" :class="{hintModElse: hintModElseType}">
      <p>{{hintCon}}</p>
    </div>

    <!-- 目前使用工具弹框 -->
    <div class="useTheTools" v-show="useTheToolsShow" @click.self="useTheToolsShow = false">
      <div class="popUpCon">
        <div class="popUpHeader">
          <p></p>
          <div>目前使用工具</div>
          <img src="@/assets/image/sailWind/icon6.png" alt="" @click.stop="useTheToolsShow = false">
        </div>

        <ul class="timeList">
          <li class="timeCon" v-for="(c, index) in meetingData" :key="index" @click="checkedBox(c.id)">
            <div class="popUpOption" :class="{popUpOptions: meetingArr.includes(c.id)}">
              <span>{{c.label}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 所属行业弹框 -->
    <div class="industryPopUp" v-show="industryShow">
      <div class="industryPopUpCon">
        <div class="industryPopUpHeader">
          <p></p>
          <div>所属行业</div>
          <img src="@/assets/image/sailWind/icon6.png" alt="" @click.stop="industryShow = false">
        </div>

        <div class="industrySystemCon">
          <div class="timeB" :class="{industryCheckeds: industryId == '1'}" @click="getIndustryOption(1, '汽车电子')">
            <span> 汽车电子 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '2'}" @click="getIndustryOption(2, '消费类电子')">
            <span> 消费类电子 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '3'}" @click="getIndustryOption(3, '家用电器')">
            <span> 家用电器 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '4'}" @click="getIndustryOption(4, '工业控制')">
            <span> 工业控制 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '5'}" @click="getIndustryOption(5, '电力及电源')">
            <span> 电力及电源 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '6'}" @click="getIndustryOption(6, '代加工行业')">
            <span> 代加工行业 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '7'}" @click="getIndustryOption(7, '芯片行业')">
            <span> 芯片行业 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '8'}" @click="getIndustryOption(8, '医疗行业')">
            <span> 医疗行业 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '9'}" @click="getIndustryOption(9, '通讯设备行业')">
            <span> 通讯设备行业 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '10'}" @click="getIndustryOption(10, '学校')">
            <span> 学校 </span>
          </div>
          <div class="timeB" :class="{industryCheckeds: industryId == '11'}" @click="getIndustryOption(11, '其他')">
            <span> 其他 </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 防抖
  import { debounce } from 'lodash';

  var word = /^([\u4E00-\u9FA5]+|[a-zA-Z]+)+$/;
  var phone = /^1[3456789]\d{9}$/;
  // var unmber = /^[0-9]+$/;
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  export default {
    data() {
      return {
        userName: '',
        userPhone: '',
        userCpName: '',
        userPostName: '',
        userEmail: '',
        userTool: '请选择',
        location: '',
        systemType: '1',
        otherInformation: '',
        timeType: '1',
        hintShow: false,
        hintTime: 1,
        hintCon: '',
        hintModElseType: 0,
        meetingData: [{
            id: 1,
            label: 'PADS'
          },
          {
            id: 2,
            label: 'Xpedition Mentor EE'
          },
          {
            id: 3,
            label: 'Altium Designer'
          },
          {
            id: 4,
            label: 'Cadence Allegro'
          },
          {
            id: 5,
            label: 'Zuken'
          },
          {
            id: 6,
            label: '其他'
          },
        ],
        meetingArr: [],
        useTheToolsShow: false,
        industryShow: false,
        industryId: '',
        industryName: '',
        logoUrl: '',
      }
    },

    computed: {
      submitEnabled() {
        return this.userName && this.userPhone && this.userCpName && this.userPostName && this.userEmail && this.meetingArr.length && this.industryId && this.location && this.systemType && this.timeType
      },
    },

    mounted() {
      document.getElementById('favicon').setAttribute('href', process.env.BASE_URL + 'pzeda.ico')
    },

    methods: {
      getSystemType(id) {
        this.systemType = id;
      },

      getTimeType(id) {
        this.timeType = id;
      },

      debouncedGetSubmit: debounce(function(){
        this.getSubmit()
      }, 500),

      getSubmit() {
        if (this.submitEnabled) {
          // 姓名
          if (word.test(this.userName) && this.userName) {
            // 手机号
            if (phone.test(this.userPhone) && this.userPhone) {
              // 公司
              if (this.userCpName) {
                // 职位
                if (this.userPostName) {
                  // 邮箱
                  if (emailRegex.test(this.userEmail) && this.userEmail) {
                    // 使用工具
                    if (this.meetingArr.length >= 1) {
                      // 所属行业
                      if(this.industryId > 0) {
                        // 试用侧重功能
                        if (this.location) {
                          // 电脑操作系统
                          if (this.systemType) {
                            // 期望测试时间
                            if (this.timeType) {
                              this.getData();
                            } else {
                              this.setHintCon('请选择您的期望测试时间')
                            }
                          } else {
                            this.setHintCon('请选择您的电脑操作系统')
                          }
                        } else {
                          this.setHintCon('请输入您的试用侧重功能')
                        }
                      } else {
                        this.setHintCon('请选择您的所属行业')
                      }
                    } else {
                      this.setHintCon('请选择您的使用工具')
                    }
                  } else {
                    if (this.userEmail != '') {
                      this.setHintCon('邮箱输入有误，请检查')
                    } else {
                      this.setHintCon('请输入您的邮箱')
                    }
                    window.scrollTo(0, 100);
                  }
                } else {
                  if (this.userPostName != '') {
                    this.setHintCon('职位有误，请检查')
                  } else {
                    this.setHintCon('请输入您的职位')
                  }
                  window.scrollTo(0, 100);
                }
              } else {
                if (this.userCpName != '') {
                  this.setHintCon('公司名称有误，请检查')
                } else {
                  this.setHintCon('请输入公司名称')
                }
                window.scrollTo(0, 100);
              }
            } else {
              if (this.userPhone != '') {
                this.setHintCon('电话有误，请检查')
              } else {
                this.setHintCon('请输入您的电话')
              }
              window.scrollTo(0, 100);
            }
          } else {
            if (this.userName != '') {
              this.setHintCon('姓名有误，请检查')
            } else {
              this.setHintCon('请输入您的姓名')
            }
            window.scrollTo(0, 0);
          }
        }
      },

      getData() {
        this.$http({
          url: '/meet/setActivityRecord',
          method: 'POST',
          params: {
            username: this.userName,
            phone: this.userPhone,
            company: this.userCpName,
            position: this.userPostName,
            email: this.userEmail,
            use_tool: this.meetingArr.join(','),
            industry: this.industryId,
            focus_feature: this.location,
            operating_system: this.systemType,
            other_information: this.otherInformation,
            test_duration: this.timeType,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.$router.push({
              path: '/sailWindSucceed',
            })
          } else {
            this.setHintCon(res.msg);
          }
        })
      },

      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },

      // 获取参会时间
      checkedBox(i) {
        if (this.meetingArr.includes(i)) {
          this.meetingArr = this.meetingArr.filter(function(ele) {
            return ele != i;
          });
        } else {
          this.meetingArr.push(i);
        }
      },

      getIndustry(){
        this.industryShow = true;
      },

      getIndustryOption(id, name) {
        this.industryId = id;
        this.industryName = name;
      },
    },
  }
</script>

<style lang="css" scoped>
  /* 申请信息 */
  .applyForInfo {
    box-sizing: border-box;
    padding: 0 1.5rem;
    padding-top: 1.15rem;
  }

  .hint {
    display: flex;
    align-items: center;
  }

  .hint p {
    width: .35rem;
    height: 1.45rem;
    background-color: #3588BF;
    margin-right: .4rem;

  }

  .hint div {
    font-size: 1.6rem;
    font-weight: 600;
    color: #333333;
  }

  .formInfo {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 6.25rem;
    border-bottom: .05rem solid #E5E5E5;
  }

  .formInfo div {
    width: 7rem;
    margin-right: 3.5rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: #555555;
  }

  .formInfo div span {
    color: #F7443F;
  }

  .formInfo img {
    width: 1.5rem;
    height: 1.5rem;
  }

  .formInfo .shade {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: #3588BF; */
  } 

  .infoInput {
    width: 22.5rem;
    height: 2.1rem;
    background-color: transparent;
    border: none;
    outline: none;
    color: #555555;
    font-size: 1.5rem;
  }

  .infoInput[name="infoInput"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  /* 申请详情 */
  .applyForParticulars {
    box-sizing: border-box;
    padding: 0 1.5rem;
    padding-top: 3.15rem;
  }

  .tool {
    box-sizing: border-box;
    padding: 2.05rem 0;
    border-bottom: .1rem solid #E5E5E5;
    display: flex;
  }

  .toolHint {
    height: 2.1rem;
  }

  .toolHint div {
    font-size: 1.5rem;
    font-weight: 600;
    color: #555555;
    margin-right: .7rem;
  }

  .toolHint div span {
    color: #F7443F;
  }

  .userTool {
    height: 2.1rem;
    display: flex;
    align-items: center;
  }

  .userTool div {
    width: 21.75rem;
    color: #C0C4CC;
    font-size: 1.5rem;
  }

  .userTool img {
    width: 1.5rem;
    height: 1.5rem;
    margin-top: .1rem;
  }

  .userToolCon {
    width: 10rem;
    display: flex;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .userToolCons {
    width: 10rem;
    display: flex;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    color: #333333;
  }

  .userToolCons span {
    color: #333333 !important;
  }

  .function {
    padding-top: 2rem;
  }

  .functionCon {
    position: relative;
    width: 100%;
    height: 11.35rem;
  }

  .userLocation {
    background-color: #F5F5F7;
    border-radius: .5rem;
    box-sizing: border-box;
    border: none;
    padding: 1.5rem;
    color: #333333;
    font-size: 1.5rem;
    width: 100%;
    height: 11.35rem;
    margin-top: 1rem;
    font-family: -webkit-body;
    resize: none;
    outline: none;
    color: #333333;
  }

  .userLocation[name="userLocation"]::-webkit-input-placeholder {
    color: #BFBFBF;
  }

  .functionCon p {
    position: absolute;
    right: 1rem;
    bottom: 0;
    font-size: 1.4rem;
  }

  .functionCon p span {
    color: #BFBFBF;
  }

  /* 系统配置 */
  .applyForAllocations {
    box-sizing: border-box;
    padding: 0 1.5rem;
    padding-top: 3.15rem;
  }

  .system {
    padding-top: 1.1rem;
  }

  .systemCon {
    display: flex;
    flex-wrap: wrap;
  }

  .systemCon div {
    width: 50%;
  }

  .systemConOption {
    box-sizing: border-box;
    color: #333333;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-top: 1.1rem;
  }

  .systemConOption:before {
    width: 1.8rem;
    height: 1.8rem;
    line-height: 1rem;
    content: "";
    border: 1px #000 solid;
    margin-right: .6rem;
    transition: all 0.1s linear;
    border: none;
    background-image: url('~@/assets/image/sailWind/icon2.png');
    background-size: cover;
  }

  .checked:before {
    background-image: url('~@/assets/image/sailWind/icon1.png');
  }

  .elseSystemCon {
    width: 100%;
  }

  .elseSystemCon input {
    width: 100%;
    height: 4.1rem;
    background-color: #F5F5F7;
    font-family: -webkit-body;
    resize: none;
    outline: none;
    border: none;
    margin-top: 1.45rem;
    border-radius: .5rem;
    box-sizing: border-box;
    padding: 0 1rem;
  }

  /* 期望测试时间 */
  .testTime {
    box-sizing: border-box;
    padding: 0 1.5rem;
    padding-top: 3.15rem;
  }

  .timeA {
    box-sizing: border-box;
    color: #333333;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-top: 1.1rem;
  }

  .timeA:before {
    width: 1.8rem;
    height: 1.8rem;
    line-height: 1rem;
    content: "";
    border: 1px #000 solid;
    margin-right: .6rem;
    transition: all 0.1s linear;
    border: none;
    background-image: url('~@/assets/image/sailWind/icon2.png');
    background-size: cover;
  }

  .checkeds:before {
    background-image: url('~@/assets/image/sailWind/icon1.png');
  }

  /* 提交按钮 */
  .submitBtn {
    box-sizing: border-box;
    width: 100%;
    padding: 3.5rem 2rem;
  }

  .submitBtn div {
    width: 100%;
    height: 4.8rem;
    background-color: rgba(53, 136, 191, 0.5);
    border-radius: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
  }

  .submitBtnElse {
    background-color: rgba(53, 136, 191, 1) !important;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 99999;
  }

  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(85, 85, 85, 0.5);
    font-size: 1.3rem;
    color: #FFF;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hintModElse p {
    background-color: rgba(0, 0, 0, 0.60);
    color: #FFFFFF;
  }

  /* 目前使用工具弹框 */
  .useTheTools {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.60);
    display: flex;
    align-items: end;
  }

  .popUpCon {
    width: 100%;
    height: 44rem;
    background-color: #FFF;
    border-radius: 2rem 2rem 0 0;
  }

  .popUpHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2.25rem 2rem;
    border-bottom: .1rem solid #E5E5E5;
  }

  .popUpHeader p {
    width: 1.5rem;
    height: 1.5rem;
  }

  .popUpHeader div {
    font-size: 1.7rem;
    font-weight: 600;
    color: #333333;
  }

  .popUpHeader img {
    width: 1.5rem;
    height: 1.5rem;
    margin-top: .4rem;
  }

  .timeList {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0 2rem;
  }

  .timeCon {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 2rem 0;
    border-bottom: .1rem solid #E5E5E5;
  }

  .timeCon:last-child {
    border-bottom: none;
  }

  .popUpOption {
    box-sizing: border-box;
    padding: 0 2rem;
    color: #333333;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
  }

  .popUpOption:before {
    width: 1.8rem;
    height: 1.8rem;
    line-height: 1rem;
    content: "";
    border: 1px #000 solid;
    margin-right: 1rem;
    transition: all 0.1s linear;
    border: none;
    background-image: url('~@/assets/image/sailWind/icon5.png');
    background-size: cover;
  }

  .popUpOptions:before {
    background-image: url('~@/assets/image/sailWind/icon4.png');
    background-size: cover;
  }

  .industryPopUp {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.60);
    display: flex;
    align-items: end;
  }

  .industryPopUpCon {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    height: 80%;
    background-color: #FFF;
    border-radius: 2rem 2rem 0 0;
    overflow-y: scroll;
  }

  .industryPopUpHeader {
    background-color: #FFF;
    box-sizing: border-box;
    width: 100%;
    position: sticky;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2.25rem 2rem;
    border-bottom: .1rem solid #E5E5E5;
  }

  .industryPopUpHeader p {
    width: 1.5rem;
    height: 1.5rem;
  }

  .industryPopUpHeader div {
    /* margin-right: 11.85rem; */
    font-size: 1.7rem;
    font-weight: 600;
    color: #333333;
  }

  .industryPopUpHeader img {
    width: 1.5rem;
    height: 1.5rem;
    margin-top: .4rem;
  }

  .industrySystemCon {
    height: 66rem;
    padding: 0 2.25rem;
    overflow-y: scroll;
  }

  .industrySystemCon .timeB {
    height: 6rem;
    box-sizing: border-box;
    color: #333333;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    border-bottom: 0.05rem solid #E5E5E5;
  }

  .industrySystemCon .timeB:last-child {
    border-bottom: none;
  }

  .timeB:before {
    width: 1.8rem;
    height: 1.8rem;
    line-height: 1rem;
    content: "";
    border: 1px #000 solid;
    margin-right: .6rem;
    transition: all 0.1s linear;
    border: none;
    background-image: url('~@/assets/image/sailWind/icon2.png');
    background-size: cover;
  }

  .industryCheckeds:before {
    background-image: url('~@/assets/image/sailWind/icon1.png');
  }
</style>